import React from 'react';

export default function DisabledSoundIcon(props) {
    return (
        <svg width='28' height='28' viewBox='0 0 28 28' {...props}>
            <path
                fill='#1D1D1B'
                fillRule='nonzero'
                d='M10.113 8.446l.07.073 1.503 1.78 2.517-1.749v4.73l1.706 2.021a8.83 8.83 0 0 0-.414-4.029l-.063-.18 1.188-.717.095.257c.415 1.117.63 2.308.63 3.528 0 .846-.104 1.677-.305 2.48l1.102 1.305c.427-1.203.649-2.478.649-3.784 0-1.497-.291-2.953-.85-4.307l-.076-.185 1.207-.713.104.243a12.647 12.647 0 0 1 1.007 4.962c0 1.738-.35 3.428-1.02 4.992-.142.38-.254.615-.337.704l-.067.066c-.304.26-.841.244-1.101-.095l-.024-.03L8.966 9.533l-.07-.073-.019-.018a.814.814 0 0 1 .11-.948l.068-.066a.795.795 0 0 1 1.058.018zM8.56 11.545l5.642 6.68v1.576l-3.234-2.248h-.362c-1.765 0-3.195-1.443-3.195-3.224v-.308c0-.995.447-1.885 1.15-2.476z'
                opacity='.198'
            />
        </svg>
    );
}
